import { GLOVE_PATH } from 'constants/paths'
import GlovePage from './components/GlovePage'

export default {
  path: GLOVE_PATH,
  component: GlovePage
}
